import ScreenSizeCard from './ScreenSizeCard';
export default ScreenSizeCard;
